import {useGetUserProfileQuery} from '../redux/api/locales';
import {PropsWithChildren} from 'react';
import dayjs from 'dayjs';

export default function DateTimeFormat(props: PropsWithChildren) {
  const {data} = useGetUserProfileQuery();
  const dateFormat = data?.language === 'it' ? 'DD/MM/YYYY, HH:mm:ss' : 'YYYY/MM/DD, HH:mm:ss';

  return <>{typeof props?.children === 'string' && props?.children ? dayjs(props?.children).format(dateFormat) : null}</>;
}